export default __webpack_public_path__ + "static/media/mode-13.89fe62bd.svg";